import { observable, computed } from "mobx";

export default class BirdHomePageStore {
  constructor(http) {
    this.http = http;
    this.init();
  }

  @observable
  updates = [];

  init = async () => {
    const params = {
      type: "BirdUpdateMessage",
      filter: {
        type: "BirdUpdateMessage",
        sort: [
          { column: "creationDate", direction: "DESC"}
        ],
      }
    };
    const resp = await this.http.fetchEntities(params);
    this.updates = (resp && resp.results) ? resp.results : [];
  };


  @computed
  get getUpdates() {
    return [...this.updates];
  }
}
